<template>
  <div class="partInfo" v-if="detailsData">
    <div>
      <div class="partInfoTitle">零件信息</div>
      <el-collapse v-model="activeNames" @change="handleChange" :border="false">
        <template  v-for="(item,index) in detailsData.rfqParts">
          <el-collapse-item  :key="index" :name="index">
            <template #title>
              零件{{ index+1 }}
              <!-- {{ rfqPartsLen }} -->
            </template>
            <div class="partInfoCounter">
              <div class="partLeft">
                <div class="partName">{{ item.name }}</div>
                <div class="partItemDiv">
                  <div class="label textBol">工艺</div>
                  <div class="value textBol">{{CategoryFromt(detailsData,item)}}</div>
                </div>
                <div class="partItemDiv">
                  <div class="label textBol">材料</div>
                  <div class="value textBol">{{material(item)}}</div>
                </div>
                <div class="partItemDiv" style="display: flex; align-items:flex-start">
                  <div class="label textBol">报价数量</div>
                  <div>
                    <div class="value textBol"><span v-if="showText(item)">第一：</span>{{ item.quoteNum1 | quantity }} {{item.quoteNum1>0?item.quoteUnitStr:'' }}</div>
                    <div class="value textBol" v-if="item.quoteNum2">第二：{{ item.quoteNum2 | quantity }} {{item.quoteNum2>0?item.quoteUnitStr:'' }}</div>
                    <div class="value textBol" v-if="item.quoteNum3">第三：{{ item.quoteNum3 | quantity }} {{item.quoteNum3>0?item.quoteUnitStr:'' }}</div>
                  </div>
                  
                </div>
                <div class="partItemDiv">
                  <div class="label textBol">交货日期</div>
                  <freightTable :freightList="item.partsDeliveryList" :quoteUnitStr="item.quoteUnitStr"
                    :totalMap="{
                      quoteNum1:item.quoteNum1,
                      quoteNum2:item.quoteNum2,
                      quoteNum3:item.quoteNum3,
                    }"
                  >
                    <template #reference>
                      <div class="value textBol cp">{{ handleFormatDateAndTime(item.partsDeliveryList) }}
                        <i class="iconfont icon-icon-xunpan" style="color: #0863FF; font-size:13px;" v-if="item.partsDeliveryList.length>1"></i>
                      </div>
                    </template>
                  </freightTable>
                </div>
                <div class="partItemDiv" v-if="item.annualUsage">
                  <div class="label">年用量预估</div>
                  <div class="value">{{ item.annualUsage | quantity }}{{item.annualUsage>0?item.quoteUnitStr:'' }}</div>
                </div>
                <div class="partItemDiv" v-if="item.showTargetUnitPrice==1">
                  <div class="label">目标采购单价</div>
                  <div class="value money">{{detailsData.currencySymbol}}{{ item.targetUnitPrice | priceFormat }}</div>
                </div>
                <div class="partItemDiv">
                  <div class="label">材料提供方</div>
                  <div class="value">{{ item.materialProviderStr||'--' }}</div>
                </div>
                <div class="partItemDiv" v-if="item.tightestTol">
                  <div class="label">最小公差</div>
                  <div class="value">{{   item.tightestTol||'--' }}{{ item.sizeUnitStr }}</div>
                </div>
                <div class="partItemDiv" v-if=" item.roughTypeStr">
                  <div class="label">表面粗糙度</div>
                  <div class="value"> {{ roughType(item) }}</div>
                </div>
                <div class="partItemDiv" v-if="item.surfaceStatus!=null">
                  <div class="label">表面处理</div>
                  <div class="value">{{surfaceDeal(item)}}</div>
                </div>
                <div class="partItemDiv" v-if="item.heatDealStrList?.length>0">
                  <div class="label">热处理</div>
                  <div class="value">{{ item.heatDealStrList?.length>0?item.heatDealStrList.join(','):'--' }}</div>
                </div>
                <div class="partItemDiv" v-if="item.machiningRequirements">
                  <div class="label">技术要求</div>
                  <div class="value">{{ item.machiningRequirements||'--' }}</div>
                </div>
              </div>
              <div class="partRight">
                <div class="partImgDiv">
                  <img
                    :src="`${partDrawingUrl}${item.partThumbnailsHashCode}`"
                    alt=""
                    class="partImg"
                    :onerror="`this.src='${defaultRfqThn}'`"
                  />
                  <!-- <img src=""  :onerror="`this.src='${ defaultRfqThn }'`" alt="" class="partImg"> -->
                </div>
                <div class="viewDrawing"  @click="viewDrawing(item)" v-if="item.attachments.length>0">
                  <i class="iconfont icon-a-3Ddrawing"></i>查看2D/3D图纸
                </div>
                <div v-else class="viewDrawingNone">
                  暂无数据
                </div>
              </div>
            </div>
          </el-collapse-item>
        </template>
      </el-collapse>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { getOnlineDrawing } from "@/utils/api/zhenyunOrder";
import { onlineUrl } from '@/utils/config';
import { companyLogoUrl,partDrawingUrl } from "@/utils/config";
import zhenyunOrderMinxis from "@/mixins/zhenyunOrder.js";
import freightTable from "./freightTable.vue";
export default {
  mixins: [zhenyunOrderMinxis],
  props:{
    detailsData:{
      default:null
    },
    partner:{
      default:0
    }
  },
  components:{
    freightTable
  },
  data(){
    return{
      partDrawingUrl,
      activeNames: [0],
      defaultRfqThn:"https://res.haizol.com/base/images/default_rfq_thumb_56_56.png",
      url:'',
      srcList: [],
      companyLogoUrl: companyLogoUrl,
      isSettledInfo:null,
      freightVisible:false
    }
  },
  watch:{ 

  },
  computed:{
    

  },
  methods:{
    // 工艺
    CategoryFromt(main,sub){
      let mainCategoryStr=main.mainCategoryStr?main.mainCategoryStr:''
      let subCategoryStr=sub.subCategoryStr?sub.subCategoryStr:''
      let CategoryStr=mainCategoryStr&&subCategoryStr?mainCategoryStr+' - '+subCategoryStr:(mainCategoryStr&&!subCategoryStr?mainCategoryStr:(!mainCategoryStr&&subCategoryStr?subCategoryStr:'--'))
      return CategoryStr
    },
    // 材料
    material(item){
      let materialStr=item.materialStr?item.materialStr:''
      let seriesStr=item.seriesStr?item.seriesStr:''
      let Str=materialStr&&seriesStr?materialStr+' - '+seriesStr:(materialStr&&!seriesStr?materialStr:(!materialStr&&seriesStr?seriesStr:'--'))
      return Str
    },
    //日期格式化
    handleFormatDateAndTime(value) {
      if (value &&value.length>0) {
        if (value.length == 1) {
          return moment(value[0]['deliveryTime']).format("YYYY-MM-DD");
        }
        return `${moment(value[0]['deliveryTime']).format("YYYY-MM-DD")}...等${value.length}个批次`;
      }
      return "--";
    },
    // 粗糙度
    roughType(item){
      let roughTypeStr=item.roughTypeStr?item.roughTypeStr:''
      let roughValue=item.roughValue?item.roughValue:''
      let Str=roughTypeStr&&roughValue?roughTypeStr+' '+roughValue:(roughTypeStr&&!roughValue?roughTypeStr:(!roughTypeStr&&roughValue?roughValue:'--'))
      return Str
    },
    // 表面处理
    surfaceDeal(item){
      let str=''
      if(item.surfaceStatus==1){
        str=item.surfaceDealStrList.length>0?item.surfaceDealStrList.join(','):'--'
      }else{
        str='无毛刺、无表面裂纹等其他问题'
      }
      return str
    },
    handleChange(val) {
      // console.log(val)
    },
    async viewDrawing(item){
      if(this.detailsData.isAcceptNda==2){
        return this.$message.warning('您的保密协议正在审核中，请耐心等待')
      }
      await this.getOnboarding(this.detailsData.clientId)
      try{
        
        const {
          authorizationLetter,
          intermediaryServiceAgreement,
          undertakingLetter,
          escrowAccount,
          platformServiceAgreement,
          myBankAuth,
          myBankChannel
        }=this.isSettledInfo
        const zhenyunFlag = [
          authorizationLetter,
          intermediaryServiceAgreement,
          undertakingLetter,
          escrowAccount,
        ].every(item=>item)
        const shukeFlag = [
          undertakingLetter,
          escrowAccount,
          platformServiceAgreement
        ].every(item=>item)
        if(!zhenyunFlag && [20,50].includes(this.detailsData.clientId)){
          // 判断是否入驻？
          this.$emit('changeDetails','viewDrawing',0)
          return 
        }
        if([30,70].includes(this.detailsData.clientId) && !shukeFlag){
          // 判断是否入驻？
          this.$emit('changeDetails','viewDrawing',0)
          return 
        }
        //判断是否完成网商银行授权
        if(myBankChannel && !myBankAuth){
          this.$emit('changeDetails','promptlyQuot',0)
          return 
        }
        if(this.detailsData.isShowAttach != 1){
          // 是否符合报价条件
          this.$emit('changeDetails','viewDrawing',2)
          return
        }
        if(this.detailsData.ndaType==2 && this.detailsData.isAcceptNda==0){
          // 判断是否二级保密协议
          this.$emit('changeDetails','promptlyQuot','nda2')
          return
        }
        if(this.detailsData.ndaType==1 && this.detailsData.isAcceptNda==0){
          // 判断是否一级保密协议
          this.$emit('changeDetails','viewDrawing',1)
          return
        }
        // if(this.detailsData.quoteQuotaFull==1){
        //   // 报名是否满额
        //   this.$emit('changeDetails','viewDrawing',3)
        //   return
        // }
        else{
          try {
            let hashCode=item.attachments?.length>0?item.attachments[0].hashCode:''
            let formData=null
            formData = new FormData()
            formData.append('encryptRfqId',this.detailsData.encryptRfqId)
            formData.append('hashCode', hashCode)
            const { data, rspResult } = await getOnlineDrawing(formData)
            const rfqQuoteId= this.$route.query.quoteId?`&rfqQuoteId=${this.$route.query.quoteId}`:''
            if (rspResult.bizCode === 200) {
              if (data.type == 1) {
                window.open(`${onlineUrl}/saas-drawing/drawing-view?folder=${data.target}&active=${hashCode}&partner=${this.partner}`+rfqQuoteId);
              } else {
                // partner 用于查看图纸后返回甄云项目  1: 全部询盘列表 ， 2: 询盘详情 (ps:如果是报价详情进入的询盘详情也需要加上rfqQuoteId)， 3：报价详情需要多加一个报价编号  rfqQuoteId  
                window.open(`${onlineUrl}/${data.url}?active=${hashCode}&partner=${this.partner}`+rfqQuoteId);  
              }
            }
          } catch (err) {
            console.error('❌ ~ getOnlineDrawing ~ err:', err)
          }
        }
      }catch{
        console.error('❌ ~ getOnboarding ~ err:', err)
      }

    },
    showText(item){
      if(!item){return false}
      if(item.quoteNum1 && !item.quoteNum2 && !item.quoteNum3){
        return false
      }
      return true
    }
  },
  mounted(){
    // 多个零件展开的情况
    let len=this.detailsData.rfqParts?.length>0?this.detailsData.rfqParts.length:0
    this.activeNames=[]
    if(len==0) return 
    for(var i=0;i<len;i++){
      this.activeNames.push(i)
    }
  },
  created(){

  }
}
</script>
<style lang="scss" scoped>
.partInfo{
  padding-top: 16px;
}
.partInfoTitle{
  color: #222222;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
}
.partInfoCounter{
  display: flex;
  padding:16px;
  .partLeft{
    .partName{
      color: #222222;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 8px;
    }
    .partItemDiv{
      display: flex;
      flex: 1;
      align-items: center;
      margin-top: 8px;
      .label{
        width: 168px;
        color: #555555;
        font-size: 14px;
        line-height: 22px;
      }
      .textBol{
        font-weight: 700;
      }
      .value{
        color: #222222;
        font-size: 14px;
        line-height: 22px;
        flex: 1;
        white-space: pre-wrap;
      }
      .money{
        color: #ff7700;
      }
    }
  }
  .partRight{
    margin-left: auto;
    .partImgDiv{
      width: 120px;
      height: 120px;
      border: 1px solid #CFD5DF;
      display: flex;
      .partImg{
        width: 100%;
        object-fit: contain;
      }
    }
    .viewDrawing{
      background: #F6F7F8;
      margin-top: 8px;
      text-align: center;
      width: 120px;
      cursor: pointer;
      i{
        font-size: 12px;
        color: #0863FF;
      }
    }
    .viewDrawingNone{
      background: #F6F7F8;
      margin-top: 8px;
      text-align: center;
      width: 120px;
      i{
        font-size: 12px;
        color: #0863FF;
      }
    }
  }
}
:deep(.el-collapse-item__header){
  background: #F5F7FA;
  padding: 0px 16px !important;
  color: #222222 !important;
  font-size: 14px;
  font-weight: 700;
  i{
    font-size: 16px;
    color: #98A3B7;
  }
}
:deep(.el-collapse){
  border: none;
}
.cp{
  cursor: pointer;
}
</style>